import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { contestActions } from '../../store/contest/contestSlice';
import { scoreboardActions } from '../../store/scoreboard/scoreboardSlice';
import ContestPage from '../../pages/ContestPage/ContestPage';
import ExternalContestPage from '../../pages/ExternalContestsPage/ExternalContestPage';

const ContestComponent = () => {

  const { activeContests, currentContestId } = useSelector(state => state.contest);
  const currentContest = activeContests?.find((c) => String(c.id) === String(currentContestId));
  const {contestId} = useParams();
  const dispatch = useDispatch();
  
  useEffect(() => {
    if (contestId && String(currentContestId) !== String(contestId)) {
      dispatch(contestActions.setCurrentContestId(contestId));
      dispatch(scoreboardActions.clearScoreboardData());
    }
  }, [contestId, currentContestId, dispatch]);

  return (
    (currentContest?.tabType === "external") ?
      <ExternalContestPage contest={currentContest} />
      :
      <ContestPage />
  )
};

export default ContestComponent;
